"use client";

import { c as _c } from "react/compiler-runtime";
import type { RatingWithProfileInfoAndLevel } from "@/entities/IProfile";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import { formatNumberWithCommas, getTimeAgo } from "@/helpers/Helpers";
import { ProfileRatersTableType } from "@/types/enums";
import Link from "next/link";
import UserCICAndLevel from "../UserCICAndLevel";
export default function ProfileRatersTableItem(t0) {
  const $ = _c(24);
  const {
    rating,
    type
  } = t0;
  const getRatingStr = _temp;
  const ratingStr = getRatingStr(rating.rating);
  const isPositiveRating = rating.rating > 0;
  const ratingColor = isPositiveRating ? "tw-text-green" : "tw-text-red";
  let t1;
  if ($[0] !== rating.last_modified) {
    t1 = getTimeAgo(new Date(rating.last_modified).getTime());
    $[0] = rating.last_modified;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeAgo = t1;
  let t2;
  if ($[2] !== rating.handle || $[3] !== type) {
    t2 = () => {
      switch (type) {
        case ProfileRatersTableType.CIC_RECEIVED:
        case ProfileRatersTableType.CIC_GIVEN:
          {
            return `/${rating.handle}/identity`;
          }
        case ProfileRatersTableType.REP_RECEIVED:
        case ProfileRatersTableType.REP_GIVEN:
          {
            return `/${rating.handle}/rep`;
          }
        default:
          {
            assertUnreachable(type);
            return "";
          }
      }
    };
    $[2] = rating.handle;
    $[3] = type;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getProfileRoute = t2;
  const profileRoute = getProfileRoute();
  let t3;
  if ($[5] !== rating.level) {
    t3 = <UserCICAndLevel level={rating.level} />;
    $[5] = rating.level;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== rating.handle) {
    t4 = <span className="tw-cursor-pointer tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-iron-200 hover:tw-underline sm:tw-text-md">{rating.handle}</span>;
    $[7] = rating.handle;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== profileRoute || $[10] !== t4) {
    t5 = <div className="tw-inline-flex tw-items-center tw-space-x-1"><Link href={profileRoute} className="tw-flex tw-items-center tw-p-0 tw-no-underline">{t4}</Link></div>;
    $[9] = profileRoute;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <td className="tw-px-4 tw-py-2.5 sm:tw-px-6 lg:tw-pr-4"><div className="tw-inline-flex tw-items-center tw-space-x-2.5">{t3}{t5}</div></td>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = `tw-whitespace-nowrap tw-text-sm tw-font-medium sm:tw-text-md ${ratingColor}`;
  let t8;
  if ($[15] !== ratingStr || $[16] !== t7) {
    t8 = <td className="tw-px-4 tw-py-2.5 tw-text-right sm:tw-px-6 lg:tw-pl-4"><span className={t7}>{ratingStr}</span></td>;
    $[15] = ratingStr;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== timeAgo) {
    t9 = <td className="tw-px-4 tw-py-2.5 tw-text-right sm:tw-px-6 lg:tw-pl-4"><span className="tw-whitespace-nowrap tw-text-sm tw-font-normal tw-text-iron-500 sm:tw-text-md">{timeAgo}</span></td>;
    $[18] = timeAgo;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t6 || $[21] !== t8 || $[22] !== t9) {
    t10 = <tr>{t6}{t8}{t9}</tr>;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
function _temp(rating_0) {
  return rating_0 > 0 ? `+${formatNumberWithCommas(rating_0)}` : `${formatNumberWithCommas(rating_0)}`;
}